import Vue from "vue";
import Router from "vue-router";

import landingPg from "@/components/pages/StaticLandingPage.vue";

import fnbcheckout from "@/components/pages/fnbcheckout.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: function() {
    return {
      x: 0,
      y: 0,
    };
  },

  routes: [
    {
      path: "/",
      name: "LandingPage",
      component: landingPg,
    },
    {
      path: "/lets-eat/:cinemaId",
      name: "foodBeverage",
      component: fnbcheckout,
    },
  ],
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js